<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Subproduto' : 'Cadastrar Subproduto' }}
            </h4>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <!-- Product code -->
              <CCol lg="6">
                <CInput
                  v-model="form.product_code"
                  label="Código do produto"
                  :disabled="true"
                />
              </CCol>

              <!-- Subproduct code -->
              <CCol lg="6">
                <CInput
                  v-model="form.subproduct_code"
                  label="Código do subproduto"
                  :disabled="true"
                />
              </CCol>

              <!-- Image -->
              <CCol col="12">
                <FileUploader
                  id="subproduct-image"
                  :uploader-info="uploaderInfo"
                  :enable-multiple="false"
                  :enable-crop-on-uploader="true"
                  :enable-edit-on-api-table="false"
                  :max-files="1"
                  :accept-types="acceptTypes"
                  :extensions="extensions"
                  :medias="form.main_image"
                  :min-cropped-width="771"
                  :min-cropped-height="428"
                  uploader-type="banner"
                  :disabled="processing"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar alterações</a>
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Modal from '@/components/ui/Modal'
import CardLog from '@/components/ui/CardLog'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/subproducts.service'
export default {
  metaInfo: {
    title: 'Subprodutos',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_products')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Modal,
    CardLog
  },

  data() {
    return {
      item: {
        subproduct_code: '',
        product_code: '',
        main_image: []
      },
      form: {},
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      subproductMedia: [],
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            product_code: data.product.code,
            subproduct_code: data.subproduct_code,
            main_image: data.main_image
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        main_image_id: this.form.main_image && this.form.main_image.length ? this.form.main_image[0].id : null
      }

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Subproduto foi atualizado com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        this.resetForm()
        setTimeout(() => {
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 3000)
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
